import React, { useState } from 'react';
import './CreateOrder.css';
import ScrapOrderForm from './ScrapOrderForm';
import StaffOrderForm from './StaffOrderForm';


const CreateOrder = () => {
    const [mode, setMode] = useState('')
    return ( 
        <div className="new-order-container">
            <header >
                <h1>ثبت سفارش جدید</h1>
            </header>
            <div>
                <section>
                    <fieldset className="d-flex flex-column">
                        <label>
                            <input 
                                type="radio" 
                                name="radio-button"  
                                onChange={e =>  e.target.checked ? setMode('staff') : setMode('')}
                            />
                            <span>ثبت درخواست متخصص</span>
                        </label>
                        <label>
                            <input 
                                type="radio" 
                                name="radio-button"  
                                onChange={e =>  e.target.checked ? setMode('scrap') : setMode('')}
                            />
                            <span>ثبت فروش ضایعات</span>
                        </label>
                    </fieldset>
                </section>
                <section>
                    {
                        mode === 'staff' && <StaffOrderForm />
                    }
                    {
                        mode === 'scrap' && <ScrapOrderForm />
                    }
                </section>
            </div>
        </div>
     );
}
 
export default CreateOrder;